<template>
  <div class="container">
    <app-header title="提现明细"/>

    <div class="recharge" v-for="item in cashList" :key='item.id'>
      <div class="rechargeme">
        <div class="title" style="position: relative;top: 11px;" v-if="item.status == 0">账户提现（审核中）</div>
        <div class="title" style="position: relative;top: 11px;" v-if="item.status == 1">账户提现（已提现）</div>
        <div class="title" style="position: relative;top: 11px;" v-if="item.status == 2">账户提现（审核不通过）</div>
        <div class="price">+￥{{item.money}}</div>
      </div>
      <div class="redate">{{item.createTime}}</div>
    </div>
    <empty v-if="cashList.length==0" />
  </div>

</template>

<script>
import { saveShopCash,getShopCashList } from '@/api/mine/cash.js'
export default {
  name: 'Detail',
  data() {
    return {
      cashList:[]
    }
  },
  created() {
    this._queryCashList()
  },
  methods: {
    // 充值记录
    _queryCashList() {
      var user = localStorage.getItem('userInfo')
      user = JSON.parse(user)
      const params = {
        uid: user.id
      }
      getShopCashList(params).then((res) => {
        this.cashList = res.data
      })
    },
    handleTag(index) {
      this.activeTag = index
      if (index == 0) {
        this.show = true
      } else {
        this.show = false
      }
    }

  }
}
</script>
<style lang="less" scoped>
  .container{
    .tabs{
      display: flex;
      flex-direction: row;
      align-items: center;
      height:44px;
      padding: 0 12px;
      .tab{
        display: flex;
        flex-direction: row;
        flex: 1;
        .item{
          font-size:14px;
          font-weight:500;
          height:22px;
          font-family:PingFang SC;
          line-height:22px;
          color:rgba(51,51,51,1);
          margin-right: 14px;
          .active{
            font-size:16px;
            font-weight:bold;
            color: #FE003B;
            border-bottom: 3px solid #FE003B;
          }
        }
      }
    }
    .recharge{
      padding: 22px;
      border-bottom: 2px solid #EDEDED;
      .rechargeme{
        display: flex;
        justify-content: space-between;
        .title{
          font-size:14px;
          font-family:PingFang SC;
          font-weight:400;
          line-height:20px;
          color:rgba(102,102,102,1);
          opacity:1;
        }
        .price{
          font-size:14px;
          font-family:PingFang SC;
          font-weight:400;
          line-height:20px;
          color:rgba(254,0,59,1);
          opacity:1;
        }
      }
      .redate{
        width:100%;
        font-size:12px;
        font-family:PingFang SC;
        font-weight:400;
        line-height:17px;
        color:rgba(136,137,136,1);
        opacity:1;
        margin-top: 14px;
        text-align: right;
        margin-right: 12px;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/views/mine/cashDetail.vue